module.exports = __webpack_public_path__ + "media/SMID-intro3.77c99d53.mp4";